export default {
    person: {
        wzTZ: '王者荣耀后台管理系统通知公告',
        wzKF: '开发者联系方式',
        QQ1: 'QQ号1',
        QQ2: 'QQ号2',
        mailbox: '邮箱',
        browser: '浏览器',
        RecommendedUse: '推荐使用',
        mattersNeedingAttention: '注意事项',
        mattersNeedingAttention1: '禁止在原有基础上修改并用于商业用途',
        mattersNeedingAttention2: '此网页对于开发者而言，仅用于交流与学习',
        version: '版本号',
    },
    home:{
        wzry:"登录",
        game:'登录',
        account:'请输入账号',
        password:'请输入密码',
        remember:'记住密码'
    },
    Login:{
        name:"欢迎",
        register:"注册",
        logon:"登录",
        ZY:"秋色微凉黯伤",
        ReSelect:"重新选择"
    }
};